export class ArrayHelper {
    private static isTypedArraySupported: boolean;

    public static realloc(buffer: Uint8Array, length: number): Uint8Array {
        const newBuffer = new Uint8Array(buffer.length + length);
        if (this.isTypedArraySupported === true || this.isTypedArraySupported === undefined) {
            try {
                newBuffer.set(buffer);
                this.isTypedArraySupported = true;
                return newBuffer;
            }
            catch (e) {
                // console.log('ArrayHelper.realloc: ' + e);
                if (this.isTypedArraySupported === undefined) {
                    this.isTypedArraySupported = false;
                }
            }
        }

        const len = buffer.length;
        for (let i = 0; i < len; i++) {
            newBuffer[i] = buffer[i];
        }
        return newBuffer;
    }

    public static copy(target: Uint8Array, offset: number, source: Uint8Array, sourceOffset?: number, length?: number): Uint8Array {
        if (this.isTypedArraySupported === true || this.isTypedArraySupported === undefined) {
            try {
                const src = sourceOffset === undefined ? source : source.subarray(sourceOffset, sourceOffset + length);
                target.set(src, offset);
                this.isTypedArraySupported = true;
                return target;
            }
            catch (e) {
                // console.log('ArrayHelper.copy: ' + e);
                if (this.isTypedArraySupported === undefined) {
                    this.isTypedArraySupported = false;
                }
            }
        }

        if (sourceOffset === undefined) {
            sourceOffset = 0;
        }
        if (length === undefined) {
            length = source.length;
        }
        for (let i = 0; i < length; i++) {
            target[i + offset] = source[i + sourceOffset];
        }
        return target;
    }

    public static getInt32(buf: Uint8Array, pos: number): number {
        let v = 0;
        for (let i = pos; i < pos + 4; i++) {
            v <<= 8;
            v |= buf[i];
        }
        return v;
    }

    public static startWith = (buf: Uint8Array, pos: number, key: string): boolean => {
        for (let i = 0; i < 4; i++) {
            if (buf[pos + i] !== key.charCodeAt(i)) return false;
        }
        return true;
    }
};
